export default __webpack_public_path__ + "static/media/commerce.bdd9cec9.png";